<template>
 
    <div style="background:#fff; margin-top:5px;margin-left:3px; "> 
        <div style="border-bottom:1px solid #ccc;border-left:2px solid #409eff">
            <el-select v-model="selparam"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:20px; ">
                <span v-for="item in tabCol" :key='item.key'>
                    <el-option :label="item.title" :value="item.key"></el-option>
                </span>
            </el-select>
            <el-select v-model="oper"  size="small" style="width:110px;margin-bottom:3px;margin-left:2px; ">
                <el-option label="等于" value="="></el-option>
                <el-option label="相似于" value="like"></el-option>
                <el-option label="大于等于" value="&ge;"></el-option>
                <el-option label="小于等于" value="&le;"></el-option>
            </el-select>
            <el-input placeholder="请输入查询值" ref="refqry" v-model="textparam" size="small" style="width:260px;margin-left:2px;margin-top:3px; ">
                <el-button size="small" slot="append" icon="el-icon-search" @click.native="qryTabData" style="color:#409eff"></el-button>
            </el-input>   
            <el-button size="mini" icon="iconfont icon-chenggong1" @click="selSure" style="color:#409eff;margin-left:30px;">确定选择</el-button>
        </div>
        <el-table :data="tmpData" 
                border                            
                disabled-hover
                style="overflow:auto;margin-top:3px;"
                v-loading="loading"
                element-loading-background = "rgba(255, 255, 255, .5)"
                element-loading-text = "加载中，请稍后..."
                element-loading-spinner = "el-icon-loading"
                size="small"
                ref="frmtab"
                :height="tabHeight" 
                @row-click="rowClick"
                @row-dblclick="selSure"
                :max-height="tabHeight" 
                highlight-current-row
                    >
            <span  v-for="(item ,index) in tabCol" :key="index">   
                <el-table-column   v-if="item.thide==='N'"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"                                  
                    sortable
                    :min-width="item.width">
                </el-table-column> 
            </span> 
                  
        </el-table>
        <!-- 提示框 -->
        <el-dialog  :visible.sync="promtWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promtWin = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
 
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user' 
 
export default {
    data () {
        return {
            oper:'like',
            input_hold:'请输入内容... 按回车键以查询',
            selparam:'',// select 绑定值
            textparam:'', // input 绑定值
            tabCol:[] ,//表列集合
            tmpData:[] ,// 
            baseData:[] ,//表数据
            disabled:false,
            empRow:{},
            promtWin:false,
            prompt:'',
            v_url:'xuper_auth/getTableRecMany' , //api请求路径      
            v_formurl:'xuper_auth/getTableRecMany', //多记录查询 like模式       
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') ,//corp id
            loading:false,// table加载bool
        }
    },
    created () {
        if (this.v_username){
            this.getTabCol() //得到 表列数组 
            this.getFormData( '') //初始查询表数据   
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/login',
                query: {},
            });
            window.open(routeUrl.href, '_self');
        }
    },
    components: {
 
    },
    mounted () {   
        this.$refs.refqry.focus()
    } ,
    computed: {
        tabHeight() {
          return  window.innerHeight -140
        },
        scrollerHeight: function() {
            return (window.innerHeight - 80) + 'px';
        }, 
    },
    methods: {  
        selSure(){
            if (this.empRow['EMPNM']){
                this.$emit('child-sure',this.empRow['IDSEQ'],this.empRow['EMPNM'])
            }else{
                this.promtWin=true
                this.prompt='请选择一记录'
            }
        },
        //表行点击事件
        rowClick(row){
            this.empRow =row
        },
        //查询表格数据
        qryTabData(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and '+this.selparam+' like \'%' + this.textparam+'%\''
                }else{
                    cond_=cond_+' and '+this.selparam +this.oper+'\''+this.textparam+'\''
                }
            }
            this.getFormData( cond_ )
        },
 
        //获取表单数据
        getFormData( cond){
            var vm=this
            this.loading =true
            console.log(cond)
            getTabColOrData(this.v_formurl,'v_HR_EMP','corpid',this.v_corpid,'','','','',cond).then((res) => {              
                if (res.code==='200'){
                    this.tmpData=res.result    
                } else{
                    this.promtWin=true
                    this.prompt=res.result
                }
                vm.loading =false         
            });            
        },
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4204','LSTSEQ','1' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.tabCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        thide: res.result[k].THIDE,
                        fhide: res.result[k].FHIDE,
                        disabled: res.result[k].DISABLED,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                    })
                }
            });
        },
    }
}
 
</script>
<style scoped lang="less" >
    .selinput{
        width:340px;
        margin-left:10px; 
    }
    .colwidth{
        width:140px;
    }
    .colwidth2{
        width:642px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    } 
    .item-width  {
        width: 48%;
        color:#409EFF;
    }
</style>
<style lang="less">
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .tree-scroll{
        width :180px;
        border: 1px solid #f5dbdb;
        height: 100%;
    }
   .el-table {
    th {
        padding: 0 ;
    }
    thead{
        height: 15px !important;
        color:rgb(128,128, 128);
        font-size:12px;
    }
    td {
        padding: 5px ;
        font-size:11px;
    }   
  }
  .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    // .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
</style>
